import React from "react";
import './FilterBar.scss';
import Icon from "../../../components/Icon";
import { useDispatch, useSelector } from "react-redux";
import { selectFilters } from "../../../store/selectors/serviceRequestDashboard/filters";
import { applyFilter, removeFilter } from "../../../store/actions/serviceRequestDashboard/filters";

const filterLabels = {
  PropertyId: "Property",
  BuildingId: "Building",
  LevelId: "Level",
  UnitId: "Units",
  TagIds: "Tags",
  SubmittedFrom: "Submitted From",
  SubmittedTo: "Submitted To",
  ServiceType: "Issue Type",
  ItemTypeId: "Asset Type",
  AssignedToServiceProviderId: "Service Provider",
}

const transformFilters = (filters) => {
  const {
    booleanFilters,
    Statuses,
    ...rest
  } = filters;
  const formattedFilters = Object.keys(rest).reduce((acc, key) => {
    if (rest[key]?.length) {
      acc.push(filterLabels[key]);
    }
    return acc;
  }, []);
  formattedFilters.push(...(booleanFilters??[]));
  return formattedFilters;
};



export const FilterBar = () => {

  const filters = useSelector(selectFilters);
  const dispatch = useDispatch();

  const handleRemoveFilter = (filter) => {
    if(filters.booleanFilters.includes(filter)){
      dispatch(applyFilter('booleanFilters', filters.booleanFilters.filter((booleanFilter) => booleanFilter !== filter)));
      return;
    }
    const key = Object.keys(filterLabels).find((key) => filterLabels[key] === filter);
    dispatch(removeFilter(key));
  };

  return (
    <div className="filter_bar">
      {transformFilters(filters).map((filter) => (
        <div key={filter} className="filter_bar__filter" onClick={() => handleRemoveFilter(filter)}>
          {filter}
          <Icon size="small" glyph="trash" weight="solid" />
        </div>
      ))}
    </div>
  );
};


